// extracted by mini-css-extract-plugin
module.exports =  {"label":"EMgCghqnD3YycoAOlpXJ","value":"nGvewrH8iKdNHnMhcbpo","statistic":"UBXN42q3Iai283yIoO0H","left":"gFuSAv8uihl71oYwp0vp","right":"FnLAo_E8q_imnY0oC_vw"};